export interface HighlightItem {
  id: string;
  cover: string;
  name: string;
  order: number;
}

export interface AvailableItem {
  id: string;
  name: string;
  cover: string;
  creatorName?: string;
}

export interface HighlightSection {
  key: string;
  name: string;
}

export interface UpdateHighlightOrderRequest {
  id: string;
  order: number | null;
}

// A API retorna diretamente um array de HighlightItem[]
export type HighlightResponse = HighlightItem[];

export interface UpdateHighlightOrderResponse {
  success: boolean;
  message?: string;
}

export interface AddItemsRequest {
  itemIds: string[];
}

export interface AddItemsResponse {
  success: boolean;
  message?: string;
}

// Seções disponíveis para gerenciamento
export const HIGHLIGHT_SECTIONS: HighlightSection[] = [
  { key: 'trending-packs', name: 'Trending Packs' },
  { key: 'top-creators', name: 'Top Creators' },
  { key: 'top-photographs', name: 'Top Photographs' },
  { key: 'popular-packs-paid', name: 'Popular Packs (Paid)' },
  { key: 'popular-presets-free', name: 'Popular Presets (Free)' },
  { key: 'banners', name: 'Banners' },
  // { key: 'new-learning', name: 'New Learning' },
  // { key: 'top-articles', name: 'Top Articles' },
];
